import { RetellWebClient } from "retell-client-js-sdk";

const rizlerStyle = document.createElement('style');
// Initialize RetellWebClient
const retellWebClient = new RetellWebClient();

class RizlerAgentPopup {
  constructor() {
    this.status = 'idle';
    this.agentId = this.getAgentId();
    this.rizhostUrl = this.getHostUrl();
    console.log('Agent ID:', this.agentId);
    console.log('rizhostUrl:', this.rizhostUrl);
    this.createPopup();
  }

  getAgentId() {
    const scriptElement = document.querySelector('script[rizler-ai-agent-id]');
    return scriptElement ? scriptElement.getAttribute('rizler-ai-agent-id') : 'defaultAgentId';
  }

  getHostUrl() {
    const scriptElement = document.querySelector('script[rizler-ai-agent-id]');
    if (scriptElement) {
      const srcUrl = scriptElement.src;
      const url = new URL(srcUrl);
      return url.origin;
    }
    return null;
  }

async  createPopup() {
    const response = await fetch(this.rizhostUrl+`/api/widget/config?agent_id=`+this.agentId);
    const data = await response.json();
    let  backgroundRizWidget = 'white';
    let  textColorRizWidget = 'black';
    let  borderRizWidget = '1px solid black';
    let  borderRadiusRizWidget = '16px';

    let  btnbackgroundColorRizWidget = 'black';
    let  btncolorRizWidget = 'rgb(255, 255, 255)';
    let  btnborderRadiusRizWidget = '10px';

    let  statCallTextRizWidget = "Start a call";
    let  endCallTextRizWidget = "End call";
    let  calltoActionTxtRizWidget = "Need help?";


    // const rizlerai_girl_image = this.rizhostUrl + '/assets/ai-girl-image.jpg';
    let rizlerai_girl_image = this.rizhostUrl + '/assets/ai-girl-image.jpg';

    let  psRizWidgetposition = 'fixed';
    let  psRizWidgettop = '';
    let  psRizWidgetbottom = '';
    let  psRizWidgetleft = '';
    let  psRizWidgetright = '';
    let  psRizWidgettransform = '';
    if (data.success) { 
        const styleConfig = data.config;  
        backgroundRizWidget = styleConfig.background_color; 
        textColorRizWidget = styleConfig.text_color; 
        borderRizWidget = `1px solid ${styleConfig.border_color}`;
        borderRadiusRizWidget = `${styleConfig.card_radius || 0}px`;

        btnbackgroundColorRizWidget = styleConfig.button_color;
        btncolorRizWidget = styleConfig.button_text_color;
        btnborderRadiusRizWidget = `${styleConfig.button_radius || 0}px`;

         statCallTextRizWidget = styleConfig.start_call_text || "Start a call";
         endCallTextRizWidget = styleConfig.end_call_text || "End call";
         calltoActionTxtRizWidget = styleConfig.call_to_action_text || "Need help?"; 

        rizlerai_girl_image = this.rizhostUrl+`/${styleConfig.avatar_image}`; 

        switch (styleConfig.popup_position) {
        case 'top-right':
          psRizWidgettop = '20px';
          psRizWidgetright = '20px';
          break;
        case 'middle-right':
          psRizWidgettop = '50%';
          psRizWidgetright = '20px';
          psRizWidgettransform = 'translateY(-50%)';
          break;
        case 'bottom-right':
          psRizWidgetbottom = '20px';
          psRizWidgetright = '20px';
          break;
        case 'top-left':
          psRizWidgettop = '20px';
          psRizWidgetleft = '20px';
          break;
        case 'middle-left':
          psRizWidgettop = '50%';
          psRizWidgetleft = '20px';
          psRizWidgettransform = 'translateY(-50%)';
          break;
        case 'bottom-left':
          psRizWidgetbottom = '20px';
          psRizWidgetleft = '20px';
          break;
        default:
          psRizWidgetbottom = '20px';
          psRizWidgetright = '20px';
        }
    } 
    rizlerStyle.textContent = `
      .rizler-agent-popup { 
          z-index: 1000; 
          display: flex; 
          align-items: center; 
          gap: 12px; 
          background: ${backgroundRizWidget}; 
          color: ${textColorRizWidget}; 
          padding: 16px 20px; 
          border: ${borderRizWidget}; 
          border-radius: ${borderRadiusRizWidget}; 
          position: ${psRizWidgetposition}; 
          top: ${psRizWidgettop}; 
          bottom: ${psRizWidgetbottom}; 
          left: ${psRizWidgetleft}; 
          right: ${psRizWidgetright}; 
          transform: ${psRizWidgettransform}; 
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1); 
          overflow: hidden;
          width: auto; 
      }


        .rizler-icon {
          width: 55px;
          height: 55px;
          border-radius: 50%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .rizler-icon img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        @keyframes gradient-rotation {
          0% { background-position: 0% 50%; transform: rotate(0deg); }
          50% { background-position: 100% 50%; transform: rotate(180deg); }
          100% { background-position: 0% 50%; transform: rotate(360deg); }
        }

        .rizler-content { flex-grow: 1; }
        .rizler-title {
          font-size: 15px;
          font-weight: 500;
          color: #1a1a1a;
          margin: 0 0 8px 0;
        }

        .rizler-controls {
          display: flex;
          gap: 8px;
          justify-content: flex-start;
        }

        .rizler-button {
          padding: 10px 40px 10px 40px;
          border: none;
          outline: none;
          color: ${btncolorRizWidget};
          background: ${btnbackgroundColorRizWidget};
          cursor: pointer;
          position: relative;
          z-index: 0;
          border-radius: ${btnborderRadiusRizWidget};
          user-select: none;
          -webkit-user-select: none;
          touch-action: manipulation;
          font-size: 14px;
          font-weight: 500;
          white-space: nowrap;
          width: 150px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-top:10px;
        }

        .rizler-button:before {
          content: "";
          background: linear-gradient(
            45deg,
            #ff0000,
            #ff7300,
            #fffb00,
            #48ff00,
            #00ffd5,
            #002bff,
            #7a00ff,
            #ff00c8,
            #ff0000
          );
          position: absolute;
          top: -2px;
          left: -2px;
          background-size: 400%;
          z-index: -1;
          filter: blur(5px);
          -webkit-filter: blur(5px);
          width: calc(100% + 4px);
          height: calc(100% + 4px);
          animation: glowing-button 20s linear infinite;
          transition: opacity 0.3s ease-in-out;
          border-radius: 10px;
        }

        .rizler-button:after {
          z-index: -1;
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          background: ${btnbackgroundColorRizWidget};
          left: 0;
          top: 0;
          border-radius: 10px;
        }

        .rizler-hidden { display: none; }

        @keyframes glowing-button {
          0% { background-position: 0 0; }
          50% { background-position: 400% 0; }
          100% { background-position: 0 0; }
        }
      `;
    document.head.appendChild(rizlerStyle);

    const popup = document.createElement('div');
    popup.className = 'rizler-agent-popup';

    popup.innerHTML = `
      <div class="rizler-icon">
        <img src="${rizlerai_girl_image}" alt="AI Support Agent" />
      </div>
      <div class="rizler-content">
        <div class="rizler-title rizler-status">${calltoActionTxtRizWidget}</div>
        <div class="rizler-controls">
          <button class="rizler-button rizler-start-button" id="rizlerStartBtn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg> ${statCallTextRizWidget}
          </button>
          <button class="rizler-button rizler-hangup-button rizler-hidden" id="rizlerHangupBtn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg> ${endCallTextRizWidget}
          </button>
        </div>
      </div>
    `;
    document.body.appendChild(popup);
    this.popup = popup; 
    this.attachEventListeners();
    this.setupRetellListeners();
}


  setupRetellListeners() {
    retellWebClient.on("call_started", () => {
      this.updateStatus('Call in progress');
    });

    retellWebClient.on("call_ended", () => {
      console.log("call ended");
      this.updateStatus('Call ended');
    });

    retellWebClient.on("agent_start_talking", () => {
      console.log("agent_start_talking");
      this.updateStatus('Agent is speaking');
    });

    retellWebClient.on("agent_stop_talking", () => {
      console.log("agent_stop_talking");
      this.updateStatus('Call in progress');
    });

    retellWebClient.on("update", (update) => {
      console.log('transcript: ', update.transcript);
    });

    retellWebClient.on("metadata", (metadata) => {
      console.log('metadata: ', metadata);
    });

    retellWebClient.on("error", (error) => {
      console.error("An error occurred:", error);
      this.stopRetellWebCall();
    });
  }

  attachEventListeners() {
    const startButton = this.popup.querySelector('#rizlerStartBtn');
    const hangupButton = this.popup.querySelector('#rizlerHangupBtn');

    startButton.addEventListener('click', async () => {
      this.status = 'running';
      startButton.classList.add('rizler-hidden');
      hangupButton.classList.remove('rizler-hidden');
      this.updateStatus('Connecting...');
      
      // Note: You need to implement this function to get your access token
      const access_token = await this.getAccessToken(); 
      await this.createRetellWebCall(access_token);
    });

    hangupButton.addEventListener('click', () => {
      this.status = 'ended';
      hangupButton.classList.add('rizler-hidden');
      startButton.classList.remove('rizler-hidden');
      this.updateStatus('Call ended.');
      this.stopRetellWebCall();
    });
  }

  updateStatus(message) {
    const statusElement = this.popup.querySelector('.rizler-status');
    statusElement.textContent = message || `Status: ${this.status}`;
  }

  async createRetellWebCall(access_token) {
    console.log(access_token);
    await retellWebClient.startCall({
      accessToken: access_token,
      sampleRate: 24000,
      captureDeviceId: "default",
      emitRawAudioSamples: false,
    });
  }

  stopRetellWebCall() { 
    retellWebClient.stopCall();
  }

  // You need to implement this method to get your access token
    async getAccessToken() {
        try {
            const url = new URL(this.rizhostUrl + '/api/widget/rizler-ai-call');
            url.searchParams.append('agent_id', this.agentId);
            console.log(url);
            const response = await fetch(url, {
                method: 'GET', 
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();
            
            if (data.status === "success") {
                return data.access_token;
            } else {
                throw new Error('Failed to get access token');
            }
        } catch (error) {
            console.error('Error getting access token:', error);
            throw error;
        }
    }
}

// Initialize popup
const rizlerAgentPopup = new RizlerAgentPopup();
 
window.addEventListener('widgetDataUpdate', (event) => {
  const data = event.detail;
  console.log('Widget data received:', data);
  const popup = document.querySelector('.rizler-agent-popup');

  if (popup) {
      // Apply position styles
      popup.style.position = 'fixed';
      popup.style.top = '';
      popup.style.bottom = '';
      popup.style.left = '';
      popup.style.right = '';
      popup.style.transform = '';

      switch (data.position) {
          case 'top-right':
              popup.style.top = '20px';
              popup.style.right = '20px';
              break;
          case 'middle-right':
              popup.style.top = '50%';
              popup.style.right = '20px';
              popup.style.transform = 'translateY(-50%)';
              break;
          case 'bottom-right':
              popup.style.bottom = '20px';
              popup.style.right = '20px';
              break;
          case 'top-left':
              popup.style.top = '20px';
              popup.style.left = '20px';
              break;
          case 'middle-left':
              popup.style.top = '50%';
              popup.style.left = '20px';
              popup.style.transform = 'translateY(-50%)';
              break;
          case 'bottom-left':
              popup.style.bottom = '20px';
              popup.style.left = '20px';
              break;
          default:
              popup.style.bottom = '20px';
              popup.style.right = '20px';
      }

      // Apply style updates
      popup.style.backgroundColor = data.backgroundColor;
      popup.style.color = data.textColor; 
      popup.style.border = `1px solid ${data.borderColor}`;
      popup.style.borderRadius = `${data.cardRadius}px`;

      console.log(`Popup position updated to: ${data.position}`);
  }

  const buttons = popup.querySelectorAll('.rizler-button');
  buttons.forEach((button) => {
     console.log('Applying button color:', data.buttonColor);
      button.style.backgroundColor = data.buttonColor; 
      button.style.color = data.buttonTextColor; 
      button.style.borderRadius = `${data.buttonRadius}px`; 
  });

  const startButton = popup.querySelector('.rizler-start-button');
  const hangupButton = popup.querySelector('.rizler-hangup-button');
  const statusElement = popup.querySelector('.rizler-title');

  if (startButton) {
      startButton.style.color = data.buttonTextColor; 
      startButton.textContent = data.startCallText;
  }
  if (hangupButton) {
      hangupButton.style.color = data.buttonTextColor;
      hangupButton.textContent = data.endCallText;
  }
  if (statusElement) {
      statusElement.style.color = data.textColor; 
      statusElement.textContent = data.callToActionText;
  }

  console.log('Widget styles updated:', data);
});
window.addEventListener('avatarImageUpdate', (event) => {
  const imageUrl = event.detail.imageUrl;
  const avatarElement = document.querySelector('.rizler-icon img');
  if (avatarElement) {
      avatarElement.src = imageUrl; // Update the avatar image dynamically
      console.log('Avatar image updated:', imageUrl);
  }
});
